import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { SearchModel } from '../../models/search.model';

// identifier
export const SEARCH_SLICE_ID = 'searchFilter';

// default state
const initialState: SearchModel = {
  query: '',
};

//slice
const searchFilterSlice = createSlice({
  name: SEARCH_SLICE_ID,
  initialState,
  reducers: {
    setFilterSearchQuery: (state: SearchModel, action: PayloadAction<string>): void => {
      state.query = action.payload;
    },
    clearFilterSearchQuery: (state: SearchModel): void => {
      state.query = '';
    },
  },
});

//selectors
export const selectFilterSearchQuery = (state: RootState) => state.searchFilter.query;

//actions
export const { setFilterSearchQuery, clearFilterSearchQuery } = searchFilterSlice.actions;

//reducer
export default searchFilterSlice;
